import React from "react";

export const AppGoogleMapsCtx = React.createContext({
  loaded: false,
});
